module.exports = __webpack_public_path__ + "static/banner-635f0dd2a895fe9aeafe65a73d535974.png";